import {Command} from './Command';
import {AddTierAction} from '../actions';
import {DeleteObjectService} from '../../delete-object.service';

export class AddTierCommand extends Command<AddTierAction> {

  private object;

  constructor(
    private deleteObjectSrvc: DeleteObjectService
  ) {
    super();
  }

  do(action: AddTierAction) {
    this.object = action.object;
  }

  undo() {
    this.deleteObjectSrvc.delete(this.object);
  }

  dispose() {
    this.object = null;
  }

}




// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/AddTierCommand.ts